import { Subject } from 'rxjs';

const fitContent$ = new Subject();

export const getFitContent$ = () => {
  return fitContent$.asObservable();
};

export const emitFitContent = () => {
  fitContent$.next(null);
};
